import { StringKey } from '../../../../lang/index';

export enum TemplateCategory {
  GRANT = 'grant',
}

export const categoryLabelKey: Record<TemplateCategory, StringKey> = {
  [TemplateCategory.GRANT]: 'GRANT',
};

export enum TemplateSubCategory {
  GRANT_AGREEMENT = 'grant-agreement',
}

export const subCategoryLabelKey: Record<TemplateSubCategory, StringKey> = {
  [TemplateSubCategory.GRANT_AGREEMENT]: 'GRANT_AGREEMENT',
};

export enum ExpirationPeriod {
  DAYS_7 = '7',
  DAYS_15 = '15',
  DAYS_30 = '30',
  DAYS_60 = '60',
  DAYS_90 = '90',
}

export const expirationPeriodLabelKey: Record<ExpirationPeriod, StringKey> = {
  [ExpirationPeriod.DAYS_7]: 'EXPIRATION_7_DAYS',
  [ExpirationPeriod.DAYS_15]: 'EXPIRATION_15_DAYS',
  [ExpirationPeriod.DAYS_30]: 'EXPIRATION_30_DAYS',
  [ExpirationPeriod.DAYS_60]: 'EXPIRATION_60_DAYS',
  [ExpirationPeriod.DAYS_90]: 'EXPIRATION_90_DAYS',
};

export enum SigningMode {
  ALL_AT_ONCE = 'all-at-once',
  SET_ORDER = 'set-order',
}

export const signingModeLabelKey: Record<SigningMode, StringKey> = {
  [SigningMode.ALL_AT_ONCE]: 'SIGNING_MODE_ALL_AT_ONCE',
  [SigningMode.SET_ORDER]: 'SIGNING_MODE_SET_ORDER',
};

export const signingModeDescriptionKey: Record<SigningMode, StringKey> = {
  [SigningMode.ALL_AT_ONCE]: 'SIGNING_MODE_ALL_AT_ONCE_DESC',
  [SigningMode.SET_ORDER]: 'SIGNING_MODE_SET_ORDER_DESC',
};
